const supportedIconNames = {
  'apple-store': require('./AppleStore'),
  'google-play': require('./GooglePlay'),
  pawcare: require('./PawCare'),
  paw: require('./Paw'),
  pawFilled: require('./PawFilled'),
  'vertical-dots': require('./VerticalDots'),
};

export default supportedIconNames;
